const isRefundFlagOn = value => value === true || value === '1' || value === 1

export const ARN_DOC_TYPE = 'arn'

const AMEX_TYPE_ALIASES = new Set([
  'american-express',
  'americanexpress',
  'amex'
])

export const normalizeCardScheme = cardType =>
  (cardType || '')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, '-')

export const isAmexCardType = cardType => {
  const normalized = normalizeCardScheme(cardType)
  if (!normalized) return false
  return AMEX_TYPE_ALIASES.has(normalized)
}

export const isAmexCardNumber = cardNumber => {
  const digits = (cardNumber || '').toString().replace(/\D/g, '')
  return /^3[47]/.test(digits)
}

export const getRefundCard = (paymentCards = []) =>
  (paymentCards || []).find(card =>
    isRefundFlagOn(card?.attributes?.used_card_refund)
  ) || null

export const isAmexRefundCard = (paymentCards = []) => {
  const refundCard = getRefundCard(paymentCards)
  if (!refundCard) return false

  const attributes = refundCard.attributes || {}
  if (isAmexCardType(attributes.card_type)) return true
  if (!attributes.card_type && isAmexCardNumber(attributes.card_number)) {
    return true
  }
  return false
}

export const getRequiredArnCount = (paymentCards = []) =>
  isAmexRefundCard(paymentCards) ? 2 : 1

export const isArnSlotFilled = doc => {
  const files = doc?.files
  if (!Array.isArray(files) || files.length === 0) return false
  return files.some(
    file =>
      file?.file_obj?.id ||
      file?.id ||
      file?.file_obj?.document_revision_id ||
      file?.document_revision_id
  )
}

export const countFilledArnSlots = (arnFiles = []) =>
  (arnFiles || []).filter(isArnSlotFilled).length

export const areRequiredArnsFilled = (arnFiles = [], paymentCards = []) => {
  if (isAmexRefundCard(paymentCards)) {
    return isArnSlotFilled(arnFiles[0]) && isArnSlotFilled(arnFiles[1])
  }
  return countFilledArnSlots(arnFiles) >= 1
}

export const getMissingAmexArnPlaceholders = (arnFiles = []) => {
  const currentLength = Array.isArray(arnFiles) ? arnFiles.length : 0
  const placeholders = []
  if (currentLength < 1) {
    placeholders.push({
      isNew: true,
      amexAutoSlot: true,
      gb_doc_type: ARN_DOC_TYPE,
      files: []
    })
  }
  if (currentLength < 2) {
    placeholders.push({
      isNew: true,
      amexAutoSlot: true,
      gb_doc_type: ARN_DOC_TYPE,
      files: []
    })
  }
  return placeholders
}

export const getArnFileId = file =>
  file?.file_obj?.id || file?.id || file?.file_obj?.document_revision_id || null

const toMergeImage = (file, selectedImages = []) => {
  const id = getArnFileId(file)
  const existing = (selectedImages || []).find(
    img => getArnFileId(img) === id || getArnFileId(img?.file_obj) === id
  )
  if (existing) return existing
  return {
    file_obj: {
      ...(file?.file_obj || file),
      gb_doc_type: ARN_DOC_TYPE
    }
  }
}

export const placeAmexArnDocumentsLast = (
  selectedImages = [],
  arnFiles = []
) => {
  const arnIds = new Set()
  ;(arnFiles || []).forEach(doc => {
    ;(doc?.files || []).forEach(file => {
      const id = getArnFileId(file)
      if (id) arnIds.add(id)
    })
  })

  const isArnImage = img => {
    const type = (
      img?.file_obj?.gb_doc_type ||
      img?.gb_doc_type ||
      ''
    ).toLowerCase()
    const id = getArnFileId(img)
    return type === ARN_DOC_TYPE || arnIds.has(id)
  }

  const rest = (selectedImages || []).filter(img => !isArnImage(img))
  const extras = []
  const arn1 = []
  const arn2 = []

  ;(arnFiles || []).forEach((doc, index) => {
    if (!isArnSlotFilled(doc)) return
    const file = doc.files[0]
    const image = toMergeImage(file, selectedImages)
    if (index === 1) {
      arn2.push(image)
    } else if (index >= 2) {
      extras.push(image)
    } else {
      arn1.push(image)
    }
  })

  return [...rest, ...extras, ...arn1, ...arn2].map((img, index) => ({
    ...img,
    order: index + 1
  }))
}
